var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0001 2.40039C2.2269 2.40039 1.6001 3.02719 1.6001 3.80039V6.40912C2.00422 6.15039 2.48464 6.00039 3.0001 6.00039H13.0001C13.5156 6.00039 13.996 6.15039 14.4001 6.40912V5.40039C14.4001 4.62719 13.7733 4.00039 13.0001 4.00039H9.13147C9.07842 4.00039 9.02755 3.97932 8.99005 3.94181L7.85868 2.81044C7.59613 2.54789 7.24003 2.40039 6.86873 2.40039H3.0001Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0001 7.20039C2.2269 7.20039 1.6001 7.82719 1.6001 8.60039V12.2004C1.6001 12.9736 2.2269 13.6004 3.0001 13.6004H13.0001C13.7733 13.6004 14.4001 12.9736 14.4001 12.2004V8.60039C14.4001 7.82719 13.7733 7.20039 13.0001 7.20039H3.0001Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeIconLight);
export default __webpack_public_path__ + "static/media/officeIcon-light.356b909f7ac1f59213d94f0c5b314f3b.svg";
export { ForwardRef as ReactComponent };